export const CONTENT_TYPE_ROUTES = {
	CHAT: 'QUALITY_REPORTING_CHAT',
	TICKET: 'QUALITY_REPORTING_TICKETS',
	FAQS: 'QUALITY_REPORTING_FAQS',
};

export const LAYOUT_VALUES = {
	DEFAULT: 'default',
	FULLSCREEN: 'fullscreen',
};
